import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import type { TypedUseQueryHookResult } from '@reduxjs/toolkit/query/react';

import type { IPaymentMethod } from 'redux-store/api/billing/billing.types';
import {
  useGetCurrentPaymentPlanQuery,
  useGetPaymentMethodsQuery,
} from 'redux-store/api/billing/billing.api';

type TUsePaymentMethodQueryOptions = Parameters<typeof useGetPaymentMethodsQuery>[1];

type TBillingBaseQuery = BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError>;

export type TUsePaymentMethodQueryResult = TypedUseQueryHookResult<
  IPaymentMethod | null,
  void,
  TBillingBaseQuery
>;

export const usePaymentMethodQuery = (
  options?: TUsePaymentMethodQueryOptions
): TUsePaymentMethodQueryResult => {
  const { data: currentPaymentPlan, isLoading: isCurrentPlanLoading } =
    useGetCurrentPaymentPlanQuery();

  const shouldSkipPaymentMethods =
    isCurrentPlanLoading || currentPaymentPlan?.hasPaymentMethod === false;

  const result = useGetPaymentMethodsQuery(undefined, {
    ...options,
    skip: options?.skip || shouldSkipPaymentMethods,
  });

  return {
    ...result,
    isLoading: isCurrentPlanLoading || result.isLoading,
  } as TUsePaymentMethodQueryResult;
};
